module.exports = __webpack_public_path__ + "hnr-logo.jpg?639ffb1f0aaeb6eaaf192174806aa2ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hnr-logo.jpg
// module id = 374
// module chunks = 0